<template>
  <div class="m-ctm-page">

    <!-- ── 搜尋列（可收合） ───────────────────────────────────── -->
    <div class="m-search-bar">
      <div class="m-search-toggle" @click="searchExpanded = !searchExpanded">
        <span><i class="el-icon-search"></i> 查詢條件</span>
        <div class="m-toggle-right">
          <span v-if="lstQuery.length > 0" class="m-cond-badge">{{ lstQuery.length }}</span>
          <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
      </div>

      <el-collapse-transition>
        <div v-show="searchExpanded" class="m-search-body">

          <!-- ── 主搜尋：行政區 + 關鍵字（同一列） ── -->
          <div class="m-section">
            <div class="m-search-row">
              <div class="m-field-inline" style="flex: 1.2;">
                <label>行政區</label>
                <DistSelection
                  v-model="selectedAreaValue"
                  width="100%"
                  @area-change="handleAreaChange"
                />
              </div>
              <div class="m-field-inline" style="flex: 1.5;">
                <label>關鍵字</label>
                <el-input
                  v-model="keyword"
                  placeholder="公司名稱 / 統一編號 / 關鍵詞"
                  clearable
                  @clear="handleClearInput"
                ></el-input>
              </div>
              <el-button type="primary" icon="el-icon-search" size="small" @click="doSearch">查詢</el-button>
              <div v-if="btnAdvFuncVisible" class="m-search-row-extra-actions">
                <el-button size="small" icon="el-icon-news" @click="handleSaveSearch">儲存搜尋條件</el-button>
                <el-button size="small" icon="el-icon-present" @click="showLoadSearch = true">載入搜尋條件</el-button>
              </div>
            </div>
          </div>

          <!-- 已選條件 Tags -->
          <div  class="m-active-tags">
            <div class="m-active-tags-row">
              <div v-if="lstQuery.length > 0" class="m-active-tags-main">
                <span class="m-filter-label m-active-tags-label">已選條件</span>
                <div class="m-active-tags-list">
                  <el-tag v-for="tag in lstQuery" @close="handleClose(tag)"
                    :key="tag" type="success" closable :disable-transitions="false"
                  >{{ tag }}</el-tag>
                </div>
              </div>
              <!-- ── 操作按鈕 ── -->
              <div class="m-search-actions m-search-actions--inline">
                <el-button v-if="btnHotTag" size="small" @click="showTagCloud = true" icon="el-icon-price-tag">熱門標籤</el-button>
                <el-button size="small" @click="doClearTags" icon="el-icon-delete">清空條件</el-button>
              </div>
            </div>
          </div>

 
          <!-- ── 篩選條件 ── -->
          <div class="m-section">
            <div class="m-filter-row">
              <span class="m-filter-label">篩選條件</span>
              
              <el-dropdown placement="bottom-start" trigger="click" @command="comStatusChangeHandler">
                <span class="m-filter-btn">公司狀況 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="全部">全部</el-dropdown-item>
                  <el-dropdown-item command="營業中">營業中</el-dropdown-item>
                  <el-dropdown-item command="非營業中">非營業中</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown placement="bottom-start" trigger="click" @command="comTypeChangeHandler">
                <span class="m-filter-btn">公司類別 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="全部">全部</el-dropdown-item>
                  <el-dropdown-item v-for="item in ComTypeList" :key="item.comType" :command="item.comType">
                    {{ item.comType }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown placement="bottom-start" trigger="click" @command="orgTypeChangeHandler">
                <span class="m-filter-btn">組織別 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="全部">全部</el-dropdown-item>
                  <el-dropdown-item v-for="item in OrgTypeList" :key="item.comType" :command="item.comType">
                    {{ item.comType }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-checkbox v-model="IsCustomer" @change="otherChangeHandler('既有客戶')">既有客戶</el-checkbox>
              <el-checkbox v-model="IsInvoice" @change="otherChangeHandler('有發票')">有發票</el-checkbox>
              <el-checkbox v-model="IsImport" @change="otherChangeHandler('有進口')">有進口</el-checkbox>
              <el-checkbox v-model="IsExport" @change="otherChangeHandler('有出口')">有出口</el-checkbox>
              <el-checkbox v-model="IsFactory" @change="otherChangeHandler('有工廠')">有工廠</el-checkbox>
            </div>
          </div>

          <!-- ── 進階條件 ── -->
          <div class="m-section">
            <div class="m-filter-row">
              <span class="m-filter-label">進階條件</span>

              <el-dropdown placement="bottom-start" trigger="click" @command="radClick">
                <span class="m-filter-btn">實收資本 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="c in capList" :key="c.value" :command="c.value">
                    {{ c.cap }}
                  </el-dropdown-item>
                  <el-dropdown-item command="custom">自訂區間</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <el-dropdown placement="bottom-start" trigger="click" @command="yearClick">
                <span class="m-filter-btn">設立年數 <i class="el-icon-arrow-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="c in yearList" :key="c.value" :command="c.value">
                    {{ c.cap }}
                  </el-dropdown-item>
                  <el-dropdown-item command="custom">自訂區間</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <div class="m-field-inline" style="flex: 0.8; min-width: 150px;">
                <label>行業代號</label>
                <IndusCodeSelection
                  v-model="selectedIndustryCode"
                  size="small"
                  @change="handleIndustryCodeChange"
                />
              </div>
            </div>
          </div>


        </div>
      </el-collapse-transition>
    </div>

    <!-- ── 結果列表 ────────────────────────────────────────────── -->
    <div class="m-result-header" v-if="totalLists > 0">
      共 <strong>{{ totalLists }}</strong> 筆結果
      <span v-if="btnAdvFuncVisible" class="m-batch-btns">
        <el-button size="mini" type="danger" icon="el-icon-plus" @click="addCustomer">新增潛在客戶</el-button>
        <el-button size="mini" type="success" icon="el-icon-plus" @click="doTags">新增標籤</el-button>
      </span>
    </div>

    <!-- ── 公司卡片列表 ──────────────────────────────────────────── -->
    <div class="m-card-list" v-loading="loading">
      <div v-if="tableData.length === 0 && !loading" class="m-empty">
        <el-empty description="暫無數據，請調整搜尋條件後查詢"></el-empty>
      </div>

      <div
        v-for="row in tableData"
        :key="row.UniComNm"
        class="m-company-card"
        :class="{ 'm-company-card--selected': isSelected(row) }"
      >
        <!-- 卡片頂列：勾選 + 公司名 -->
        <div class="m-card-top">
          <el-checkbox
            v-if="btnAdvFuncVisible"
            :value="isSelected(row)"
            @change="toggleSelect(row)"
            class="m-card-check"
          ></el-checkbox>
          <span class="m-card-unicom" @click="doShowCompanyDetail(row)">{{ row.UniComNm }}</span>
          <div class="m-card-name" @click="doshowDetail(row)">
            {{ row.ComName }}
          </div>
          <!-- 基本資訊 -->
          <div class="m-card-info">
            <span v-if="row.Cap">
              <i class="el-icon-money"></i> {{ formatCapital(row.Cap) }}
            </span>
            <span v-if="row.ApvDt">
              <i class="el-icon-date"></i> {{ row.ApvDt }}
            </span>
            <span v-if="row.ComLoc" class="m-card-loc">
              <i class="el-icon-location-outline"></i> {{ row.ComLoc }}
            </span>
          </div>                      
          <!-- 動作按鈕 -->
          <div class="m-card-actions">
            <el-button
              size="mini"
              icon="el-icon-map-location"
              @click="doshowMap(row)"
            >地圖</el-button>
            <el-button
              size="mini"
              icon="el-icon-school"
              @click="doShowSimilarCompany(row)"
            >相似企業</el-button>
            <el-button              
              size="mini"
              icon="el-icon-tickets"
              @click="openTagDrawer(row)"
            >標籤</el-button>
          </div>            
          
        </div>

        <!-- 標籤列 -->
        <div class="m-card-tags" v-if="row.tags_array && row.tags_array.length > 0">
          <el-tag
            v-for="tag in row.tags_array"
            :key="tag"
            type="success"
            size="mini"
            class="m-tag"
          >{{ tag }}</el-tag>
        </div>




      </div>
    </div>

    <!-- ── 分頁 ──────────────────────────────────────────────── -->
    <div class="m-pagination" v-if="totalLists > 0">
      <Pagination
        @currentChange="pageChange"
        :pageSize="listQuery.Page_Size"
        :propsCurrentPage="listQuery.Page_Num"
        :totalLists="totalLists"
      ></Pagination>
    </div>

    <!-- ── 標籤資訊抽屜 ──────────────────────────────────────── -->
    <el-drawer
      :title="selectedCompanyTags.company ? selectedCompanyTags.company.ComName + ' 標籤資訊' : '標籤資訊'"
      :visible.sync="tagDrawerVisible"
      direction="ltr"
      size="30%"
      :with-header="true"
    >
      <div class="m-tag-drawer" v-if="selectedCompanyTags.company">
        <div class="m-tags-section" v-if="splitHqTags && splitHqTags.length > 0">
          <div class="m-tags-section-title"><i class="el-icon-collection-tag"></i> 總行標籤 ({{ splitHqTags.length }})</div>
          <div class="m-tags-wrap">
            <el-tag v-for="(tag, i) in splitHqTags" :key="'hq-' + i" type="success" size="small">
              <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '總行標籤')" style="color: #67c23a; text-decoration: underline;">{{ tag.name }}</a>
            </el-tag>
          </div>
        </div>
        <div class="m-tags-section" v-if="splitBrTags && splitBrTags.length > 0">
          <div class="m-tags-section-title"><i class="el-icon-collection"></i> 自訂標籤 ({{ splitBrTags.length }})</div>
          <div class="m-tags-wrap">
            <el-tag v-for="(tag, i) in splitBrTags" :key="'br-' + i" type="success" size="small">
              <a href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '自訂標籤')" style="color: #67c23a; text-decoration: underline;">{{ tag.name }}</a>
            </el-tag>
          </div>
        </div>
        <div class="m-tags-section" v-if="splitStdTags && splitStdTags.length > 0">
          <div class="m-tags-section-title"><i class="el-icon-collection-tag"></i> 標準標籤 ({{ splitStdTags.length }})</div>
          <div class="m-tags-wrap">
            <el-tag v-for="(tag, i) in splitStdTags" :key="'std-' + i" type="success" size="small">
              <a v-if="tag.isHyperLink" href="javascript:void(0)" @click="handleTagClick(tag.name, tag.category || '', '標準標籤')" style="color: #67c23a; text-decoration: underline;">{{ tag.name }}</a>
              <span v-else>{{ tag.name }}</span>
            </el-tag>
          </div>
        </div>
        <div v-if="(!splitBrTags || splitBrTags.length === 0) && (!splitHqTags || splitHqTags.length === 0) && (!splitStdTags || splitStdTags.length === 0)" style="text-align: center; padding: 24px; color: #999;">
          此公司暫無標籤資訊
        </div>
        <div v-if="btnAdvFuncVisible" class="m-tag-drawer-add">
          <el-button type="primary" icon="el-icon-plus" style="width: 100%;" @click="openAddTagDialog">新增標籤</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- ── 新增標籤 dialog ────────────────────────────────────── -->
    <el-dialog title="新增標籤" :visible.sync="showTag" width="92%" center>
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>公司名稱</label>
          <div class="m-form-value">{{ getSelectedComNames() }}</div>
        </div>
        <div class="m-form-item" v-if="newTagFormType === 'hq'">
          <label>標籤類型</label>
          <el-radio-group v-model="newTagFormTypeMulti">
            <el-radio label="hq">總行標籤</el-radio>
            <el-radio label="br">自訂標籤</el-radio>
          </el-radio-group>
        </div>
        <div class="m-form-item">
          <label>標籤內容（多個標籤用逗號 , 隔開）</label>
          <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" icon="el-icon-plus" @click="saveNewTag()">儲存</el-button>
        <el-button @click="showTag = false">取消</el-button>
        
      </span>
    </el-dialog>

    <!-- ── 從標籤抽屜新增標籤 dialog ─────────────────────────── -->
    <el-dialog title="新增標籤" :visible.sync="showAddTagDialog" width="92%" center>
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>公司名稱</label>
          <div class="m-form-value">{{ selectedCompanyTags.company ? selectedCompanyTags.company.ComName : '' }}</div>
        </div>
        <div class="m-form-item" v-if="newTagFormType === 'hq'">
          <label>標籤類型</label>
          <el-radio-group v-model="selectedCompanyTags.type">
            <el-radio label="hq">總行標籤</el-radio>
            <el-radio label="br">自訂標籤</el-radio>
          </el-radio-group>
        </div>
        <div class="m-form-item">
          <label>標籤內容（多個標籤用逗號 , 隔開）</label>
          <el-input v-model="newTagForm.content" placeholder="請輸入標籤內容"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddTagDialog = false">取消</el-button>
        <el-button v-if="btnAdvFuncVisible" type="primary" @click="saveNewTagFromDrawer">儲存</el-button>
      </span>
    </el-dialog>

    <!-- ── 熱門標籤 dialog ────────────────────────────────────── -->
    <el-dialog title="熱門標籤" :visible.sync="showTagCloud" width="60%" center custom-class="m-hot-tag-dialog">
      <div class="dialogBox">
                <div style="text-align: center;color: #FF0000;">
                    <h2>請點選以下的文字</h2>
                </div>        
                <div style="cursor: pointer;">
                    <wordcloud
                        :data="hotTagsList"
                        nameKey="TagName"
                        valueKey="Weight"
                        :rotate="rotateText"
                        :color="myColors"
                        :showTooltip="false"
                        :wordClick="wordClickHandler"
                        :fontSize="[20, 30]"
                        :fontSizeRatio="1.2"
                        :padding="20">
                    </wordcloud>
                </div>
      </div>
      <br/><br/><br/><br/><br/><br/>
      <span slot="footer">
        <el-button type="primary" @click="showTagCloud = false">關閉</el-button>
      </span>
    </el-dialog>

    <!-- ── 儲存搜尋條件 dialog ────────────────────────────────── -->
    <el-dialog title="儲存搜尋條件" :visible.sync="showSaveSearch" width="92%" center>
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>條件名稱</label>
          <el-input v-model="ssName" placeholder="輸入儲存條件的名稱" clearable></el-input>
        </div>
        <div class="m-form-item">
          <label>查詢條件</label>
          <div class="m-tags-wrap">
            <el-tag v-for="tag in lstQuery" :key="tag" type="success">{{ tag }}</el-tag>
          </div>
        </div>
        <div class="m-form-item">
          <label>條件備註</label>
          <el-input
            v-model="ssDesc"
            type="textarea"
            :rows="2"
            placeholder="簡明描述儲存此查詢條件的原因"
            clearable
          ></el-input>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveSearch"><font-awesome-icon icon="plus"  style="margin-right:5px;" />儲存</el-button>
        <el-button type="danger" @click="showSaveSearch = false"><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>        
      </span>
    </el-dialog>

    <!-- ── 載入搜尋條件 dialog ────────────────────────────────── -->
    <el-dialog title="載入搜尋條件" :visible.sync="showLoadSearch" width="92%" center>
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>條件名稱</label>
          <el-select v-model="selSaveSearch" placeholder="請選擇條件" no-data-text="無數據" @change="changeSaveSearch" style="width: 100%;">
            <el-option label="請選擇" value=""></el-option>
            <el-option :label="item.name" :value="item.name" v-for="item in saveSearchList" :key="item.name"></el-option>
          </el-select>
        </div>
        <div class="m-form-item">
          <label>查詢條件</label>
          <div class="m-tags-wrap">
            <el-tag v-for="tag in lstLoadQuery" :key="tag" type="success">{{ tag }}</el-tag>
          </div>
        </div>
        <div class="m-form-item">
          <label>條件備註</label>
          <el-input v-model="lssDesc" type="textarea" :rows="2" readonly></el-input>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="loadSaveSearch"><font-awesome-icon icon="plus"  style="margin-right:5px;" />載入</el-button>
        <el-button type="danger" @click="showLoadSearch = false"><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        
      </span>
    </el-dialog>

    <!-- ── 新增潛在客戶 dialog ────────────────────────────────── -->
    <el-dialog title="新增潛在客戶" :visible.sync="showPotCustomer" width="92%" center>
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>公司名稱</label>
          <div class="m-form-value">{{ checkedCompanies }}</div>
        </div>
        <div class="m-form-item">
          <label>專案名稱</label>
          <div style="display: flex; gap: 8px;">
            <el-select v-model="selectedProjectName" placeholder="請選擇" no-data-text="無數據" @change="getDeptList" style="flex: 1;">
              <el-option label="請選擇" value=""></el-option>
              <el-option :label="item.ProjectName" :value="item.ID" v-for="item in ProjectNameList" :key="item.ID"></el-option>
            </el-select>
            <el-dropdown trigger="click" @command="handleProjectName">
              <el-button type="primary" size="small">操作 <i class="el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="add">新增專案</el-dropdown-item>
                <el-dropdown-item command="edit">修改專案</el-dropdown-item>
                <el-dropdown-item command="delete">刪除專案</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveCustomer()"><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增</el-button>
        <el-button type="danger" @click="showPotCustomer = false"><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        
      </span>
    </el-dialog>

    <!-- ── 自訂資本額 dialog ───────────────────────────────────── -->
    <el-dialog title="自訂資本額區間" :visible.sync="showCustomCapital" width="92%" center>
      <el-form label-width="80px">
        <el-form-item label="起始金額">
          <el-input v-model="customCapital.start" placeholder="萬元" type="number">
            <template slot="append">萬元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="結束金額">
          <el-input v-model="customCapital.end" placeholder="萬元" type="number">
            <template slot="append">萬元</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showCustomCapital = false">取消</el-button>
        <el-button type="primary" @click="confirmCustomCapital">確定</el-button>
      </span>
    </el-dialog>

    <!-- ── 自訂設立日期 dialog ────────────────────────────────── -->
    <el-dialog title="自訂設立日期區間" :visible.sync="showCustomYear" width="92%" center>
      <el-form label-width="80px">
        <el-form-item label="起始年限">
          <el-input v-model="customYear.start" placeholder="年" type="number">
            <template slot="append">年</template>
          </el-input>
        </el-form-item>
        <el-form-item label="結束年限">
          <el-input v-model="customYear.end" placeholder="年" type="number">
            <template slot="append">年</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showCustomYear = false">取消</el-button>
        <el-button type="primary" @click="confirmCustomYear">確定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import wordcloud from 'vue-wordcloud';
import { notify, handleError } from '../../../utils/notify';
import DistSelection from '../../../components/DistSelection.vue';
import IndusCodeSelection from '@/components/IndusCodeSelection.vue';
import Pagination from '../../../components/Pagination.vue';
import {
  formatCurrency,
  formatCapital,
  formatDate,
  formatAddressBrief,
  formatBriefing,
  extractIndustryCode,
  splitIndustryCode,
} from '../../../utils/formatters';

export default {
  name: 'MobileCtm',
  components: { DistSelection, IndusCodeSelection, Pagination, wordcloud },

  data() {
    return {
      // ── Mobile UI ──────────────────────────────────────────
      searchExpanded: true,
      loading: false,
      selectedRows: [],  // 勾選的公司（行動版改為 array 手動管理）

      // ── 顯示控制 ───────────────────────────────────────────
      btnAdvFuncVisible: false,
      tagDrawerVisible: false,
      showAddTagDialog: false,
      showTag: false,
      showPotCustomer: false,
      showTagCloud: false,
      showSaveSearch: false,
      showLoadSearch: false,
      showCustomCapital: false,
      showCustomYear: false,

      // ── 標籤抽屜 ───────────────────────────────────────────
      splitStdTags: [],
      selectedCompanyTags: {
        company: null,
        type: 'br',
        br_tags: [],
        hq_tags: [],
      },
      newTagFormType: 'br',
      newTagFormTypeMulti: 'br',
      newTagForm: { content: '', type: 'br' },

      // ── 搜尋條件 ───────────────────────────────────────────
      selectedAreaValue: ['全部', '全部'],
      keyword: '',
      selectedIndustryCode: [],
      lstQuery: [],
      queryConditions: {
        keyword: '',
        companyStatus: '',
        companyType: [],
        orgType: [],
        isCustomer: false,
        isInvoice: false,
        isImport: false,
        isExport: false,
        isFactory: false,
        capital: { start: '', end: '', range: '' },
        setupDate: { range: '', start: '', end: '', rangeValue: '' },
        industryCode: [],
        preciseTags: [],
        location: { area: '', city: '', district: '' },
        geolocation: { Latitude: '', Longitude: '', Distance: '' },
        comloc: '',
      },
      queryConditionMap: new Map(),

      selectedComStatus: '全部',
      selectedOrgType: '全部',
      selectedComType: '全部',

      IsImport: false,
      IsExport: false,
      IsInvoice: false,
      IsCustomer: false,
      IsFactory: false,

      radCap: '',
      yearCap: '',
      TotCapStart: '',
      TotCapEnd: '',
      customCapital: { start: '', end: '' },
      customYear: { start: '', end: '' },

      // ── 結果資料 ───────────────────────────────────────────
      tableData: [],
      totalLists: 0,
      listQuery: {
        comLoc: '',
        searchContent: '',
        totCap: ['', ''],
        Page_Size: 10,
        Page_Num: 1,
      },

      // ── 靜態清單 ───────────────────────────────────────────
      OrgTypeList: [
        { comType: '股份有限公司' },
        { comType: '有限公司' },
        { comType: '獨資' },
        { comType: '合夥' },
        { comType: '其他' },
      ],
      ComTypeList: [
        { comType: '上市' },
        { comType: '上櫃' },
        { comType: '興櫃' },
        { comType: '公開發行' },
      ],
      capList: [
        { cap: '2000萬(含)以下',         value: 1, start: 0,     end: 2000 },
        { cap: '2001萬~3000萬(含)以下',  value: 2, start: 2001,  end: 3000 },
        { cap: '3001萬~8000萬(含)以下',  value: 3, start: 3001,  end: 8000 },
        { cap: '8001萬~1億(含)以下',     value: 4, start: 8001,  end: 10000 },
        { cap: '1億(不含)以上',           value: 5, start: 10001, end: 999999999 },
      ],
      yearList: [
        { cap: '未滿1年',        start: 0,  end: 1,  value: 1 },
        { cap: '1年以上-未滿3年', start: 1,  end: 3,  value: 2 },
        { cap: '3年以上-未滿5年', start: 3,  end: 5,  value: 3 },
        { cap: '5年以上-未滿10年',start: 5,  end: 10, value: 4 },
        { cap: '10年(含)以上',    start: 10, end: 20, value: 5 },
      ],
      areaList: [
        { area: '全部', cities: ['全部'] },
        { area: '北部', cities: ['臺北市', '新北市', '桃園市', '新竹市', '新竹縣', '宜蘭縣', '基隆市'] },
        { area: '中部', cities: ['臺中市', '彰化縣', '苗栗縣', '南投縣', '雲林縣'] },
        { area: '南部', cities: ['高雄市', '臺南市', '嘉義市', '嘉義縣', '屏東縣'] },
        { area: '東部', cities: ['花蓮縣', '臺東縣', '澎湖縣', '金門縣', '連江縣'] },
      ],
      preciseTagMappings: [
          { key: 'invest_area', title: '對外投資', isHyperlink: true },
          { key: 'is_china_fund', title: '陸資來台投資', isHyperlink: true },
          { key: 'is_invest_china', title: '赴中國大陸投資', isHyperlink: true },
          { key: 'award_name', title: '獲獎記錄', isHyperlink: true },
          { key: 'certification', title: '專業認證', isHyperlink: true },
          { key: 'domain_name', title: '企業領域', isHyperlink: true },
          { key: 'brand_name', title: '品牌商標', isHyperlink: true },
          { key: 'park_name', title: '所在園區', isHyperlink: true },
          { key: 'alarm_item', title: '裁罰警示', isHyperlink: true },
          { key: 'industry', title: '相關產業', isHyperlink: true },
          { key: 'industry_type', title: '相關產業', isHyperlink: true },
          { key: 'product', title: '相關產品', isHyperlink: true },
          {key: 'hq_category', title: '總行標籤', isHyperlink: true},
          {key: 'br_category', title: '自訂標籤', isHyperlink: true},
          {key: 'company_type', title: '公司類別', isHyperlink: true},
          {key: 'is_import', title: '進口廠商', isHyperlink: true},
          {key: 'is_export', title: '出口廠商', isHyperlink: true},
          {key: 'is_supplier', title: '合格供應商 ', isHyperlink: true},
          {key: 'import_value', title: '進口實績 ', isHyperlink: true},
          {key: 'export_value', title: '出口實績 ', isHyperlink: true},

      ],


      btnHotTag: false,
      // 潛在客戶相關
      checkedCompanies: '',
      selectedProjectName: '',
      ProjectNameList: [],

      // 熱門標籤
      hotTagsList: [],
      myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef'],
      rotateText: { from: 0, to: 0, numOfOrientation: 5 },

      // 儲存/載入搜尋條件
      ssName: '',
      ssDesc: '',
      selSaveSearch: '',
      lstLoadQuery: [],
      lssDesc: '',
      saveSearchList: [],

      selectedCity: '全部',
      selectedDistrict: '',
    };
  },

  computed: {
    splitBrTags() {
      if (Array.isArray(this.selectedCompanyTags.br_tags)) {
        return this.selectedCompanyTags.br_tags.filter(t => t && t.name && t.name.trim().length > 0);
      }
      return [];
    },
    splitHqTags() {
      if (Array.isArray(this.selectedCompanyTags.hq_tags)) {
        return this.selectedCompanyTags.hq_tags.filter(t => t && t.name && t.name.trim().length > 0);
      }
      return [];
    },
  },

  watch: {
    '$route.query.keyword': {
      immediate: false,
      handler() {
        this.applyRouteKeywordSearch();
      },
    },
  },

  methods: {
    // ── 格式化工具 ──────────────────────────────────────────
    formatCurrency,
    formatCapital,
    formatDate,
    formatAddressBrief,
    formatBriefing,
    extractIndustryCode,
    splitIndustryCode,

    // ── 勾選管理（行動版改為手動） ────────────────────────
    isSelected(row) {
      return this.selectedRows.some(r => r.UniComNm === row.UniComNm);
    },
    toggleSelect(row) {
      const idx = this.selectedRows.findIndex(r => r.UniComNm === row.UniComNm);
      if (idx === -1) this.selectedRows.push(row);
      else this.selectedRows.splice(idx, 1);
    },

    // ── 標籤抽屜 ─────────────────────────────────────────
    yearFormat(value) {
      if (!value || value.length < 4) return '';
      return value.slice(0, 4) + '年';
    },

    getStdTags() {
      // 二元性的標籤，不需要有hyperlink
      const binaryTagKeys = ["au_company_type","au_is_import","au_is_export","au_is_factory","au_is_supplier","au_is_china_fund"];      
      let stdTags = [];
      if (this.selectedCompanyTags.company) {
        for (const key in this.selectedCompanyTags.company) {
          if (key.startsWith('au_') && this.selectedCompanyTags.company[key]) {
            this.selectedCompanyTags.company[key]?.forEach(item => {
              // let tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`;
              let tagStr = item.display_name || item.name || '';
              if (item.category === 'export_value') {
                tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 出口 ${item.name || ''}級`;
              }
              if (item.category === 'import_value') {
                tagStr = `${item.event_date ? this.yearFormat(item.event_date) : ''} 進口 ${item.name || ''}級`;
              }
              stdTags.push({
                name: tagStr.trim(),
                category: item.category || key.replace('au_', ''),
                isHyperLink: binaryTagKeys.includes(key) ? false : true,
              });
            });
          }
        }
      }
      return stdTags;
    },

    handleTagClick(tagStr, tagCategory, tagType = '標準標籤') {
      this.$queryRecord(this, tagStr, 'tag', tagType);
      const routeData = this.$router.resolve({
        name: 'm-ctm',
        query: {
          keyword: tagStr,
          category: tagCategory,
          type: tagType,
        },
      });
      window.open(routeData.href, '_blank');      
    },

    openTagDrawer(item) {
      this.selectedCompanyTags = {
        company: item,
        type: 'br',
        br_tags: item.br_category || [],
        hq_tags: item.hq_category || [],
      };
      this.splitStdTags = this.getStdTags();
      this.tagDrawerVisible = true;
    },
    openAddTagDialog() {
      this.newTagForm.content = '';
      this.showAddTagDialog = true;
    },

    async saveNewTagFromDrawer() {
      if (!this.newTagForm.content.trim()) {
        notify({ title: '請注意', type: 'warning', message: '請輸入標籤內容' });
        return;
      }
      if (!this.selectedCompanyTags.company) {
        notify({ title: '請注意', type: 'warning', message: '未選擇公司' });
        this.showAddTagDialog = false;
        return;
      }
      const tagArray = this.newTagForm.content.split(',').map(t => t.trim()).filter(t => t !== '');
      const params = { UniComNm: this.selectedCompanyTags.company.UniComNm, TagValues: tagArray };
      const api = this.selectedCompanyTags.type === 'hq'
        ? this.$api.apitags.add_hq_category_tag(params)
        : this.$api.apitags.add_category_tag(params);
      api.then(() => {
        notify({ type: 'success', title: '成功', message: `已成功新增標籤` });
        setTimeout(() => this.getList(), 1000);
      }).catch(err => handleError(err, '新增標籤失敗'));
      this.tagDrawerVisible = false;
      this.showAddTagDialog = false;
    },

    async saveNewTag() {
      if (!this.newTagForm.content.trim()) {
        notify({ title: '請注意', type: 'warning', message: '請輸入標籤內容' });
        return;
      }
      if (!this.selectedRows.length) {
        notify({ title: '請注意', type: 'warning', message: '未選擇公司' });
        return;
      }
      const tagArray = this.newTagForm.content.split(',').map(t => t.trim()).filter(t => t !== '');
      this.getSelectedUniComNms().forEach(uniComNm => {
        const params = { UniComNm: uniComNm, TagValues: tagArray };
        const api = this.newTagFormTypeMulti === 'hq'
          ? this.$api.apitags.add_hq_category_tag(params)
          : this.$api.apitags.add_category_tag(params);
        api.then(() => {
          notify({ type: 'success', title: '成功', message: '已成功新增標籤' });
        }).catch(err => handleError(err, '新增標籤失敗'));
      });
      this.newTagForm.content = '';
      this.selectedRows = [];
      this.showTag = false;
    },

    getSelectedComNames() {
      if (!this.selectedRows.length) return '';
      if (this.selectedRows.length > 1) return this.selectedRows[0].ComName + ' 等 ' + this.selectedRows.length + ' 筆';
      return this.selectedRows[0].ComName;
    },
    getSelectedUniComNms() {
      return this.selectedRows.map(r => r.UniComNm);
    },

    // ── 分頁 ─────────────────────────────────────────────
    async pageChange(val) {
      this.listQuery.Page_Num = val;
      await this.getList();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    // ── 導航：行動版改為開新視窗─────────
    doShowCompanyDetail(data) {
      // this.$queryRecord && this.$queryRecord(this, data.ComName, 'company');
      // const routeData = this.$router.resolve({
      //   name: 'm-ctm-map-com',
      //   query: { unicomnm: data.UniComNm },
      // });
      // window.open(routeData.href, '_blank');

            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名

            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		      
    },

    doshowDetail(row) {
      this.$queryRecord && this.$queryRecord(this, row.ComName, 'company');
      const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
      window.open(url, '_blank');
      // const routeData = this.$router.resolve({
      //   name: 'm-ctm-map-com',
      //   query: { unicomnm: row.UniComNm },
      // });
      // window.open(routeData.href, '_blank');
    },

    doshowMap(row) {
      const fulladr = this.fullAddress(row);

      const routeData = this.$router.resolve({
        name: 'm-ctm-map',
        query: { searchmode: 'exact', unicomnm: row.UniComNm, comname: row.ComName, lat: row.Latitude, lng: row.Longitude, loc: fulladr, indusNum: row.IndusNm },
      });
      window.open(routeData.href, '_blank');
    },

    doShowSimilarCompany(data) {
      let indusCodes = [];
      if (data.IndusNm)  indusCodes.push({ IndusType: data.IndusType,  IndusNm: data.IndusNm  });
      if (data.IndusNm1) indusCodes.push({ IndusType: data.IndusType1, IndusNm: data.IndusNm1 });
      if (data.IndusNm2) indusCodes.push({ IndusType: data.IndusType2, IndusNm: data.IndusNm2 });
      if (data.IndusNm3) indusCodes.push({ IndusType: data.IndusType3, IndusNm: data.IndusNm3 });
      const routeData = this.$router.resolve({
        name: 'ctmDetail', 
        query: { indusCodes: JSON.stringify(indusCodes), id: data.UniComNm, city: data.City, district: data.District },
      });
      window.open(routeData.href, '_blank');
    },

    fullAddress(detail) {
      if (!detail || !Object.keys(detail).length) return '';
      let address = '';
      if (detail.City)     address += detail.City;
      if (detail.District) address += detail.District;
      if (detail.Street)   address += detail.Street;
      if (detail.No)       address += detail.No + '號';
      return address;
    },

    // ── 搜尋邏輯（與桌面版相同）──────────────────────────
    doSearch() {
      if (this.keyword && this.keyword.trim() !== '') {
        this.lstQuery = this.lstQuery.filter(tag => {
          const mapping = this.queryConditionMap.get(tag);
          return !mapping || mapping.type !== 'keyword';
        });
        this.addQueryCondition('keyword', this.keyword, this.keyword);
      }
      this.listQuery.Page_Num = 1;
      if (this.keyword) this.$queryRecord && this.$queryRecord(this, this.keyword, 'keyword');
      this.searchExpanded = false;
      this.getList();
    },

    handleClearInput() {
      this.lstQuery = this.lstQuery.filter(tag => {
        const mapping = this.queryConditionMap.get(tag);
        return !mapping || mapping.type !== 'keyword';
      });
      this.queryConditions.keyword = '';
    },

    handleClose(tag) {
      this.removeQueryCondition(tag);
    },

    doClearTags() {
      this.clearAllQueryConditions();
    },

    handleSaveSearch() {
      if (this.lstQuery.length === 0) {
        notify({ type: 'warning', title: '警告', message: '請先加入查詢條件後再儲存' });
        return;
      }
      this.showSaveSearch = true;
    },

    loadSaveSearchfromAPI() {
      if (!this.btnAdvFuncVisible) {
        this.saveSearchList = [];
        return;
      }
      
      this.$api.apisc.sc_search({}).then((res) => {
        console.log('儲存搜尋條件列表:', res.data);
        this.saveSearchList = (res.data || []).map(item => {
          const queryTags = item.Parameters ? Object.entries(item.Parameters).map(([key, value]) => {
            switch (key) {
              case 'keyword':
              case 'companyStatus':
                return value || null;
              case 'companyType':
              case 'orgType':
              case 'industryCode':
                return value || null;
              case 'isCustomer':
                return value ? '既有客戶' : null;
              case 'isInvoice':
                return value ? '有發票' : null;
              case 'isImport':
                return value ? '有進口' : null;
              case 'isExport':
                return value ? '有出口' : null;
              case 'isFactory':
                return value ? '有工廠' : null;
              case 'capital':
                return (value && value.start && value.end) ? `${value.start}萬~${value.end}萬` : null;
              case 'setupDate':
                return (value && value.range) ? value.range : null;
              case 'location':
                return (value && (value.city || value.district)) ? `${value.city || ''}${value.district || ''}` : null;
              case 'comloc':
                return value || null;
              default:
                return null;
            }
          }).flat().filter(x => x !== null) : [];

          return {
            name: item.ConditionName,
            memo: item.Memo || '',
            query: queryTags,
            conditions: item.Parameters || {},
          };
        });
      }).catch(() => {
        this.saveSearchList = [];
      });
    },

    saveSearch() {
      const conditionName = (this.ssName || '').trim();
      const memo = (this.ssDesc || '').trim();

      if (!conditionName) {
        notify({ type: 'warning', title: '警告', message: '請輸入搜尋條件名稱' });
        return;
      }

      if (conditionName.length > 100) {
        notify({ type: 'warning', title: '警告', message: '條件名稱不得超過100個字' });
        return;
      }

      if (memo.length > 100) {
        notify({ type: 'warning', title: '警告', message: '條件備註不得超過100個字' });
        return;
      }

      this.$api.apisc.sc_create({
        ConditionName: conditionName,
        Memo: memo,
        Parameters: this.queryConditions,
      }).then(() => {
        notify({ type: 'success', title: '成功', message: `已成功儲存搜尋條件: ${conditionName}` });
        this.loadSaveSearchfromAPI();
        this.showSaveSearch = false;
        this.ssName = '';
        this.ssDesc = '';
      }).catch(err => handleError(err, '儲存搜尋條件失敗'));
    },

    changeSaveSearch() {
      const qry = this.saveSearchList.find(x => x.name === this.selSaveSearch);
      if (!qry) {
        this.lstLoadQuery = [];
        this.lssDesc = '';
        return;
      }
      this.lstLoadQuery = qry.query || [];
      this.lssDesc = qry.memo || '';
    },

    loadSaveSearch() {
      const saved = this.saveSearchList.find(x => x.name === this.selSaveSearch);
      if (!saved) {
        notify({ type: 'warning', title: '警告', message: '請先選擇要載入的條件' });
        return;
      }

      this.clearAllQueryConditions();
      this.selectedAreaValue = ['全部', '全部'];

      const cond = saved.conditions || {};
      for (const key of Object.keys(cond)) {
        const val = cond[key];
        if (val === null || val === undefined || val === '') continue;

        switch (key) {
          case 'keyword':
            this.addQueryCondition('keyword', val, val);
            break;
          case 'companyStatus':
            this.addQueryCondition('companyStatus', val, val);
            break;
          case 'companyType':
            if (Array.isArray(val)) val.forEach(v => this.addQueryCondition('companyType', v, v));
            break;
          case 'orgType':
            if (Array.isArray(val)) val.forEach(v => this.addQueryCondition('orgType', v, v));
            break;
          case 'isCustomer':
            if (val) this.addQueryCondition('isCustomer', true, '既有客戶');
            break;
          case 'isInvoice':
            if (val) this.addQueryCondition('isInvoice', true, '有發票');
            break;
          case 'isImport':
            if (val) this.addQueryCondition('isImport', true, '有進口');
            break;
          case 'isExport':
            if (val) this.addQueryCondition('isExport', true, '有出口');
            break;
          case 'isFactory':
            if (val) this.addQueryCondition('isFactory', true, '有工廠');
            break;
          case 'capital':
            if (val && (val.start || val.end || val.range)) {
              const capDisplay = val.range || ((val.start && val.end) ? `${val.start}萬~${val.end}萬` : '');
              this.addQueryCondition('capital', val, capDisplay);
            }
            break;
          case 'setupDate':
            if (val && (val.start || val.end || val.range)) {
              const sdDisplay = val.range || ((val.start && val.end) ? `${val.start} ~${val.end}` : '');
              this.addQueryCondition('setupDate', val, sdDisplay);
            }
            break;
          case 'industryCode':
            if (Array.isArray(val)) val.forEach(code => this.addQueryCondition('industryCode', code, code));
            break;
          case 'location':
            if (val && (val.city || val.district || val.area)) {
              let displayText = '';
              if (val.city && val.district) displayText = `${val.city}${val.district}`;
              else if (val.city) displayText = val.city;
              else if (val.area) displayText = val.area;
              this.addQueryCondition('location', { area: val.area || '', city: val.city || '', district: val.district || '' }, displayText);
            }
            break;
          case 'comloc':
            if (val) this.addQueryCondition('comloc', val, val);
            break;
          default:
            break;
        }
      }

      this.keyword = this.queryConditions.keyword || '';
      this.IsCustomer = !!this.queryConditions.isCustomer;
      this.IsInvoice = !!this.queryConditions.isInvoice;
      this.IsImport = !!this.queryConditions.isImport;
      this.IsExport = !!this.queryConditions.isExport;
      this.IsFactory = !!this.queryConditions.isFactory;

      if (this.queryConditions.location && (this.queryConditions.location.city || this.queryConditions.location.district || this.queryConditions.location.area)) {
        const loc = this.queryConditions.location;
        this.selectedAreaValue = [loc.area || '全部', loc.city || '全部'];
      }

      this.showLoadSearch = false;
      this.getList();
    },

    handleAreaChange(values) {
      if (!values || values.length === 0) {
        this.selectedCity = '全部';
        this.selectedDistrict = '';
        return;
      }
      this.removePreviousLocationTags();
      if (values.length >= 3) {
        const area = values[0];
        const city = values[1];
        const district = values[2];
        const txtAddress = `${city}${district}`;
        this.selectedCity = city;
        this.selectedDistrict = district;
        this.listQuery.comLoc = txtAddress;
        this.addQueryCondition('location', { area, city, district }, txtAddress);
      } else if (values.length === 2) {
        const area = values[0];
        const city = values[1];
        this.selectedDistrict = '';
        if (city !== '全部') {
          this.selectedCity = city;
          this.listQuery.comLoc = city;
          this.addQueryCondition('location', { area, city, district: '' }, city);
        }
      } else if (values.length === 1 && values[0] !== '全部') {
        this.selectedCity = '全部';
        this.selectedDistrict = '';
        this.addQueryCondition('location', { area: values[0], city: '', district: '' }, values[0]);
      }
    },

    removePreviousLocationTags() {
      const locationPatterns = ['北部', '中部', '南部', '東部',
        '臺北市', '新北市', '桃園市', '臺中市', '臺南市', '高雄市',
        '新竹市', '新竹縣', '苗栗縣', '彰化縣', '南投縣', '雲林縣',
        '嘉義市', '嘉義縣', '屏東縣', '宜蘭縣', '花蓮縣', '臺東縣',
        '澎湖縣', '金門縣', '連江縣', '基隆市',
      ];
      this.lstQuery = this.lstQuery.filter(tag => {
        const isLoc = locationPatterns.some(p => tag.includes(p)) || /.*[市縣區鄉鎮].*/.test(tag);
        return !isLoc;
      });
    },

    handleIndustryCodeChange(value, selectedItems) {
      if (!value || value.length === 0) {
        return;
      }
      const code = value[value.length - 1];
      const displayText = (selectedItems && Array.isArray(selectedItems) && selectedItems.length > 0)
        ? (selectedItems[selectedItems.length - 1].label || code)
        : code;

      this.addQueryCondition('industryCode', code, displayText);

      this.selectedIndustryCode = [];
    },

    comStatusChangeHandler(value) {
      ['全部', '營業中', '非營業中'].forEach(t => {
        if (this.lstQuery.includes(t)) this.removeQueryCondition(t);
      });
      if (value && value !== '全部') this.addQueryCondition('companyStatus', value, value);
      this.selectedComStatus = value;
    },

    comTypeChangeHandler(value) {
      if (value === '全部') {
        this.ComTypeList.forEach(item => {
          if (this.lstQuery.includes(item.comType)) this.removeQueryCondition(item.comType);
        });
      } else {
        this.addQueryCondition('companyType', value, value);
      }
      this.selectedComType = value;
    },

    orgTypeChangeHandler(value) {
      if (value === '全部') {
        this.OrgTypeList.forEach(item => {
          if (this.lstQuery.includes(item.comType)) this.removeQueryCondition(item.comType);
        });
      } else {
        this.addQueryCondition('orgType', value, value);
      }
      this.selectedOrgType = value;
    },

    otherChangeHandler(value) {
      const map = {
        '既有客戶': { type: 'isCustomer', checked: this.IsCustomer },
        '有發票':   { type: 'isInvoice',  checked: this.IsInvoice },
        '有進口':   { type: 'isImport',   checked: this.IsImport },
        '有出口':   { type: 'isExport',   checked: this.IsExport },
        '有工廠':   { type: 'isFactory',  checked: this.IsFactory },
      };
      const cond = map[value];
      if (cond) {
        if (cond.checked) this.addQueryCondition(cond.type, true, value);
        else this.removeQueryCondition(value);
      }
    },

    radClick(val) {
      if (val === 'custom') { this.showCustomCapital = true; return; }
      const capInfo = this.capList.find(x => x.value === val);
      const displayText = `${capInfo.start}萬~${capInfo.end}萬`;
      this.capList.forEach(cap => {
        if (this.lstQuery.includes(cap.cap)) this.removeQueryCondition(cap.cap);
      });
      if (this.queryConditions.capital && this.queryConditions.capital.range) {
        this.removeQueryCondition(this.queryConditions.capital.range);
      }
      this.addQueryCondition('capital', { start: capInfo.start, end: capInfo.end, range: displayText }, displayText);
      this.radCap = val;
    },

    confirmCustomCapital() {
      const start = parseFloat(this.customCapital.start);
      const end   = parseFloat(this.customCapital.end);
      if (!start || !end) { notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束金額' }); return; }
      if (start >= end)   { notify({ type: 'warning', title: '警告', message: '起始金額必須小於結束金額' }); return; }
      const displayText = `${start}萬~${end}萬`;
      this.addQueryCondition('capital', { start, end, range: displayText }, displayText);
      this.customCapital.start = '';
      this.customCapital.end = '';
      this.showCustomCapital = false;
    },

    yearClick(val) {
      if (val === 'custom') { this.showCustomYear = true; return; }
      const yearInfo = this.yearList.find(x => x.value === val);
      const displayText = yearInfo.cap;
      const currentYear = new Date().getFullYear();
      const startDate = `${currentYear - yearInfo.end}-01-01`;
      const endDate   = `${currentYear - yearInfo.start}-12-31`;
      this.addQueryCondition('setupDate', { range: displayText, start: startDate, end: endDate, rangeValue: val }, displayText);
      this.yearCap = val;
    },

    confirmCustomYear() {
      const start = parseInt(this.customYear.start);
      const end   = parseInt(this.customYear.end);
      if (!start || !end) { notify({ type: 'warning', title: '警告', message: '請輸入完整的起始和結束年限' }); return; }
      if (start >= end)   { notify({ type: 'warning', title: '警告', message: '起始年限必須小於結束年限' }); return; }
      const displayText = `${start}年~${end}年`;
      const currentYear = new Date().getFullYear();
      this.addQueryCondition('setupDate', {
        range: displayText,
        start: `${currentYear - end}-01-01`,
        end:   `${currentYear - start}-12-31`,
        rangeValue: 'custom',
      }, displayText);
      this.customYear.start = '';
      this.customYear.end   = '';
      this.showCustomYear = false;
    },

    getPreciseTagTitle(tagKey) {
        if (!tagKey) return '';
        const tagInfo = this.preciseTagMappings.find(item => item.key === tagKey);
        return tagInfo ? tagInfo.title : tagKey;
    },

    buildTagDisplayText(tag, value, fallbackDisplayText = '') {
        if (!tag) return fallbackDisplayText;
        const title = this.getPreciseTagTitle(tag);

        let keyword = '';
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            keyword = value.display_name || value.name || value.keyword || '';
        } else if (value !== null && value !== undefined) {
            keyword = String(value);
        }

        if (!keyword) return fallbackDisplayText || title;
        return `${title}:${keyword}`;
    },

    addQueryCondition(type, value, displayText, tag = '') {
      const resolvedDisplayText = this.buildTagDisplayText(tag, value && value.name ? value.name : value, displayText);

      // 設立日期為單選：加入新條件前，先移除既有 setupDate 標籤與映射
      if (type === 'setupDate') {
        this.lstQuery = this.lstQuery.filter(tag => {
          const mapping = this.queryConditionMap.get(tag);
          const shouldRemove = mapping && mapping.type === 'setupDate';
          if (shouldRemove) this.queryConditionMap.delete(tag);
          return !shouldRemove;
        });
      }

      if (resolvedDisplayText && !this.lstQuery.includes(resolvedDisplayText)) this.lstQuery.push(resolvedDisplayText);
      switch (type) {
        case 'keyword':      this.queryConditions.keyword = value; break;
        case 'companyStatus': this.queryConditions.companyStatus = value; break;
        case 'companyType':
          if (!this.queryConditions.companyType.includes(value)) this.queryConditions.companyType.push(value); break;
        case 'orgType':
          if (!this.queryConditions.orgType.includes(value)) this.queryConditions.orgType.push(value); break;
        case 'isCustomer': this.queryConditions.isCustomer = value; break;
        case 'isInvoice':  this.queryConditions.isInvoice = value; break;
        case 'isImport':   this.queryConditions.isImport = value; break;
        case 'isExport':   this.queryConditions.isExport = value; break;
        case 'isFactory':  this.queryConditions.isFactory = value; break;
        case 'capital':    this.queryConditions.capital = value; break;
        case 'setupDate':  this.queryConditions.setupDate = value; break;
        case 'industryCode':
          if (!this.queryConditions.industryCode.includes(value)) this.queryConditions.industryCode.push(value); break;
        case 'preciseTag': {
          const preciseTag = value && typeof value === 'object'
            ? { category: value.category || tag, name: value.name || '' }
            : { category: tag, name: value };
          if (!preciseTag.category || !preciseTag.name) break;
          const exists = this.queryConditions.preciseTags.some(item => item.category === preciseTag.category && item.name === preciseTag.name);
          if (!exists) this.queryConditions.preciseTags.push(preciseTag);
          break;
        }
        case 'location': this.queryConditions.location = value; break;
        case 'comloc':   this.queryConditions.comloc = value; break;
      }
      if (resolvedDisplayText) {
        this.queryConditionMap.set(resolvedDisplayText, { type, value, tag });
      }
    },

    removeQueryCondition(displayText) {
      const idx = this.lstQuery.indexOf(displayText);
      if (idx > -1) this.lstQuery.splice(idx, 1);
      const mapping = this.queryConditionMap.get(displayText);
      if (mapping) {
        const { type, value, tag } = mapping;
        switch (type) {
          case 'keyword':      this.queryConditions.keyword = ''; this.keyword = ''; break;
          case 'companyStatus': this.queryConditions.companyStatus = ''; this.selectedComStatus = '全部'; break;
          case 'companyType':  { const i = this.queryConditions.companyType.indexOf(value); if (i > -1) this.queryConditions.companyType.splice(i, 1); break; }
          case 'orgType':      { const i = this.queryConditions.orgType.indexOf(value);     if (i > -1) this.queryConditions.orgType.splice(i, 1); break; }
          case 'isCustomer':   this.queryConditions.isCustomer = false; this.IsCustomer = false; break;
          case 'isInvoice':    this.queryConditions.isInvoice  = false; this.IsInvoice  = false; break;
          case 'isImport':     this.queryConditions.isImport   = false; this.IsImport   = false; break;
          case 'isExport':     this.queryConditions.isExport   = false; this.IsExport   = false; break;
          case 'isFactory':    this.queryConditions.isFactory  = false; this.IsFactory  = false; break;
          case 'capital':      this.queryConditions.capital    = { start: '', end: '', range: '' }; this.TotCapStart = ''; this.TotCapEnd = ''; this.radCap = ''; break;
          case 'setupDate':    this.queryConditions.setupDate  = { range: '', start: '', end: '', rangeValue: '' }; this.yearCap = ''; break;
          case 'industryCode': { const i = this.queryConditions.industryCode.indexOf(value); if (i > -1) this.queryConditions.industryCode.splice(i, 1); break; }
          case 'preciseTag': {
            const preciseTag = value && typeof value === 'object'
              ? { category: value.category || tag, name: value.name || '' }
              : { category: tag, name: value };
            this.queryConditions.preciseTags = this.queryConditions.preciseTags.filter(item => !(item.category === preciseTag.category && item.name === preciseTag.name));
            break;
          }
          case 'location':     this.queryConditions.location = { area: '', city: '', district: '' }; this.selectedCity = '全部'; this.selectedDistrict = ''; this.selectedAreaValue = ['全部', '全部']; break;
          case 'comloc':     this.queryConditions.comloc = ''; this.listQuery.comLoc = ''; break;
        }
        this.queryConditionMap.delete(displayText);
      }
    },

    clearAllQueryConditions() {
      this.lstQuery = [];
      this.queryConditions = {
        keyword: '', companyStatus: '', companyType: [], orgType: [],
        isCustomer: false, isInvoice: false, isImport: false, isExport: false, isFactory: false,
        capital: { start: '', end: '', range: '' },
        setupDate: { range: '', start: '', end: '', rangeValue: '' },
        industryCode: [],
        preciseTags: [],
        location: { area: '', city: '', district: '' },
        geolocation: { Latitude: '', Longitude: '', Distance: '' },
        comloc: '',
      };
      this.queryConditionMap.clear();
      this.keyword = ''; this.selectedComStatus = '全部'; this.selectedComType = '全部'; this.selectedOrgType = '全部';
      this.IsCustomer = false; this.IsInvoice = false; this.IsImport = false; this.IsExport = false; this.IsFactory = false;
      this.TotCapStart = ''; this.TotCapEnd = ''; this.radCap = ''; this.yearCap = '';
      this.selectedCity = '全部'; this.selectedDistrict = ''; this.selectedIndustryCode = [];
      this.selectedAreaValue = ['全部', '全部'];
      this.listQuery.comLoc = ''; this.listQuery.searchContent = ''; this.listQuery.totCap = ['', ''];
    },

    async wordClickHandler(name, value) {
      this.$queryRecord && this.$queryRecord(this, name, 'tag', '總行標籤');
      this.showTagCloud = false;
      const routeData = this.$router.resolve({
        name: 'm-ctm',
        query: {
          keyword: name,
          category: 'hq_category',
          type: '總行標籤',
        },
      });
      window.open(routeData.href, '_blank');
    },

    // ── 潛在客戶 ─────────────────────────────────────────
    async addCustomer() {
      if (!this.selectedRows.length) {
        notify({ type: 'warning', title: '警告', message: '請先勾選欲新增為潛在客戶的公司' });
        return;
      }
      this.checkedCompanies = this.selectedRows.length > 1
        ? this.selectedRows[0].ComName + '...等' + this.selectedRows.length + '個公司'
        : this.selectedRows[0].ComName;
      await this.loadProjectNameList();
      this.showPotCustomer = true;
    },

    async doTags() {
      if (!this.selectedRows.length) {
        notify({ type: 'warning', title: '警告', message: '請先勾選欲新增標籤的公司' });
        return;
      }
      this.showTag = true;
    },

    saveCustomer() {
      if (!this.selectedProjectName) {
        notify({ type: 'warning', title: '警告', message: '請先選擇專案名稱' });
        return;
      }
      this.selectedRows.forEach(row => {
        const qry = { UniComNm: row.UniComNm, ComName: row.ComName, ProjectID: this.selectedProjectName };
        this.$api.apipocx.pocx_create(qry).then(response => {
          if (response.statuscode == 200)
            notify({ type: 'success', title: '成功', message: `已成功新增潛在客戶: ${row.ComName}` });
          else
            notify({ type: 'error', title: '失敗', message: `新增失敗: ${row.ComName}` });
        }).catch(err => handleError(err, '新增潛在客戶失敗'));
      });
      this.selectedRows = [];
      this.showPotCustomer = false;
    },

    async getDeptList() {},

    handleProjectName(command) {
      if (command === 'add')    this.addProjectName();
      else if (command === 'edit')   this.editProjectName();
      else if (command === 'delete') this.deleteProjectName();
    },

    async loadProjectNameList() {
      if (!this.btnAdvFuncVisible) {
        this.ProjectNameList = [];
        return;
      }

      try {
        const res = await this.$api.apipocxpj.pocxpj_search({});
        this.ProjectNameList = res.data || [];
      } catch (e) { /* 忽略 */ }
    },

    async addProjectName() {
      this.$prompt('請輸入新的專案名稱', '新增專案名稱', {
        confirmButtonText: '確定', cancelButtonText: '取消',
        inputPattern: /.+/, inputErrorMessage: '專案名稱不可為空',
      }).then(async ({ value }) => {
        const exists = this.ProjectNameList.some(item => item.ProjectName === value.trim());
        if (exists) { notify({ title: '警告', message: `專案名稱已存在`, type: 'warning' }); return; }
        try {
          const res = await this.$api.apipocxpj.pocxpj_create({ ProjectName: value.trim() });
          await this.loadProjectNameList();
          this.selectedProjectName = res.data.ID;
          notify({ title: '成功', message: `成功新增專案名稱`, type: 'success' });
        } catch (err) { handleError(err, '新增專案名稱失敗'); }
      }).catch(() => {});
    },

    editProjectName() {
      if (!this.selectedProjectName) { notify({ title: '警告', message: '請先選擇專案名稱', type: 'warning' }); return; }
      this.$prompt('請輸入新的專案名稱', '修改專案名稱', {
        confirmButtonText: '確定', cancelButtonText: '取消',
        inputPattern: /.+/, inputErrorMessage: '專案名稱不可為空',
      }).then(async ({ value }) => {
        try {
          await this.$api.apipocxpj.pocxpj_update({ ID: this.selectedProjectName, ProjectName: value.trim() });
          await this.loadProjectNameList();
          notify({ title: '成功', message: `成功修改專案名稱`, type: 'success' });
        } catch (err) { handleError(err, '修改專案名稱失敗'); }
      }).catch(() => {});
    },

    deleteProjectName() {
      if (!this.selectedProjectName) { notify({ title: '警告', message: '請先選擇專案名稱', type: 'warning' }); return; }
      const proj = this.ProjectNameList.find(item => item.ID == parseInt(this.selectedProjectName));
      this.$confirm(`確定要刪除專案 "${proj.ProjectName}" 及其所有潛在客戶嗎?`, '刪除確認', {
        confirmButtonText: '確定', cancelButtonText: '取消', type: 'warning',
      }).then(async () => {
        try {
          await this.$api.apipocxpj.pocxpj_delete({ ID: this.selectedProjectName });
          await this.loadProjectNameList();
          this.selectedProjectName = '';
          this.$message({ type: 'success', message: '已成功刪除' });
        } catch (err) { handleError(err, '刪除專案名稱失敗'); }
      }).catch(() => {});
    },

    // ── 熱門標籤 ─────────────────────────────────────────
    loadHotTags() {
      this.$api.apihottags.getAllHotTags({ isSys: true }).then(res => {
        this.hotTagsList = res.data;
          // 取出第11個, 因為前面10個是系統預設的熱門標籤, 
          const enabledHotTags = this.hotTagsList[10];
          console.log('第11個熱門標籤（用於控制按鈕顯示）:', enabledHotTags);
          if( enabledHotTags.TagName=="Y" ) {
              this.btnHotTag = true;
          }
          else {
              this.btnHotTag = false;
          }   
          console.log('熱門標籤顯示狀態:', this.btnHotTag);   
          this.hotTagsList = this.hotTagsList.slice(0,10);        
        const maxWeight = 20;
        this.hotTagsList.forEach((tag, index) => {
          tag.Weight = Math.max(1, Math.round(Math.log(maxWeight - index + 1)));
        });
      }).catch(err => handleError(err, '取得熱門標籤失敗'));
    },

    // ── 取得列表（API 邏輯與桌面版 ctm.vue 相同）──────────
    async getList() {
      this.loading = true;
      this.$store.dispatch('loadingHandler', true);
      try {
        const qry = {
          Page_Size: this.listQuery.Page_Size,
          Page_Num:  this.listQuery.Page_Num,
        };

        const cond = this.queryConditions;

        // 地區（selectedAreaValue 優先）
        if (this.selectedAreaValue && this.selectedAreaValue.length >= 2) {
          if (this.selectedAreaValue[1] && this.selectedAreaValue[1] !== '全部') qry.City = this.selectedAreaValue[1];
        }
        if (this.selectedAreaValue && this.selectedAreaValue.length >= 3) {
          if (this.selectedAreaValue[2] && this.selectedAreaValue[2] !== '全部') qry.District = this.selectedAreaValue[2];
        }
        // location 條件優先覆蓋
        if (cond.location) {
          if (cond.location.city && cond.location.city !== '全部') qry.City = cond.location.city;
          if (cond.location.district && cond.location.district !== '') qry.District = cond.location.district;
        }

        // 關鍵字（多關鍵字空格分割）
        if (cond.keyword && cond.keyword.length > 0) {
          qry.SearchText = cond.keyword.trim().split(/\s+/);
        }

        // 公司狀況
        if (cond.companyStatus) {
          if (cond.companyStatus === '營業中')   qry.DataStatus = ['new', 'modify'];
          else if (cond.companyStatus === '非營業中') qry.DataStatus = ['delete'];
        }

        // 公司類別、組織別
        if (cond.companyType && cond.companyType.length > 0) qry.AuComType = cond.companyType;
        if (cond.orgType     && cond.orgType.length > 0)     qry.ComType   = cond.orgType;

        // 布林條件
        if (cond.isCustomer) qry.IsExistingCustomer = 'Y';
        if (cond.isInvoice)  qry.HasInvoice = 'Y';
        if (cond.isImport)   qry.HasImport  = 'Y';
        if (cond.isExport)   qry.HasExport  = 'Y';
        if (cond.isFactory)  qry.HasFactory = 'Y';

        // 資本額（轉換成元）
        if (cond.capital && cond.capital.range) {
          qry.CapMin = cond.capital.start * 10000;
          qry.CapMax = cond.capital.end   * 10000;
        }

        // 設立日期
        if (cond.setupDate && cond.setupDate.range) {
          qry.Start_Date = cond.setupDate.start;
          qry.End_Date   = cond.setupDate.end;
        }

        // 行業代號
        if (cond.industryCode && cond.industryCode.length > 0) qry.IndusNm = cond.industryCode;

        // 處理精確標籤查詢
        if (this.queryConditions.preciseTags && this.queryConditions.preciseTags.length > 0) {
            qry.PreciseTags = this.queryConditions.preciseTags.map(tagItem => ({
                    category: tagItem.category,
                    display_name: tagItem.display_name || tagItem.name
            }));
        }

        // 地理位置
        if (cond.geolocation && cond.geolocation.Latitude && cond.geolocation.Distance) {
          qry.Latitude  = cond.geolocation.Latitude;
          qry.Longitude = cond.geolocation.Longitude;
          qry.Distance  = cond.geolocation.Distance;
        }

        // 地址關鍵字（同地址搜尋）
        if (cond.comloc) qry.ComLoc = cond.comloc;

        console.log('查詢參數:', qry);
        const res = await this.$api.apies.search_bidmain(qry);
        this.tableData = res.data || [];
        // 與桌面版相同，產生 tags_array
        this.tableData.forEach(item => {
          item.tags_array = this.showTags(item);
        });
        this.totalLists = parseInt(res.total) || 0;
      } catch (err) {
        handleError(err, '查詢失敗，請稍後再試');
      } finally {
        this.loading = false;
        this.$store.dispatch('loadingHandler', false);
      }
    },

    // 與桌面版相同：依欄位產生標籤陣列
    showTags(detail) {
      const ret = [];
      if (detail.au_comtype?.length > 0)      ret.push(detail.au_comtype);
      if (detail.au_industrytype?.length > 0)  ret.push(detail.au_industrytype);
      if (detail.au_is_import || detail.au_is_export) ret.push('出進口');
      if (detail.au_is_factory)    ret.push('工廠');
      if (detail.au_is_supplier)   ret.push('供應商');
      if (detail.au_is_china_fund) ret.push('陸資');
      if (detail.au_invest_area)   ret.push('投資');
      if (detail.au_is_invest_china) ret.push('赴大陸');
      if (detail.au_award_name)    ret.push('獲獎');
      if (detail.au_certification) ret.push('認證');
      if (detail.au_domain_name)   ret.push('領域');
      if (detail.au_brand_name)    ret.push('商標');
      if (detail.au_park_name)     ret.push('園區');
      if (detail.au_alarm_item)    ret.push('裁罰');
      return ret;
    },

    async getFunctions() {
      try {
        const funs = this.$store.getters.userInfo;
        if (funs && (funs.Role || funs.RoleName)) {
          const roles = Array.isArray(funs.Role)
            ? funs.Role
            : [funs.Role || funs.RoleName || ''];
          const normalizedRoles = roles.map(r => String(r).toLowerCase());
          this.btnAdvFuncVisible = !normalizedRoles.some(r => ['do', 'apa', 'ap'].includes(r));
        }
      } catch (e) { /* 忽略 */ }
    },

    rebuildFromQueryConditions(conditions) {
      if (!conditions || typeof conditions !== 'object') {
        return;
      }

      this.clearAllQueryConditions();

      if (conditions.keyword) {
        this.addQueryCondition('keyword', conditions.keyword, conditions.keyword);
      }

      if (conditions.companyStatus) {
        this.addQueryCondition('companyStatus', conditions.companyStatus, conditions.companyStatus);
      }

      if (Array.isArray(conditions.companyType)) {
        conditions.companyType.forEach(item => this.addQueryCondition('companyType', item, item));
      }

      if (Array.isArray(conditions.orgType)) {
        conditions.orgType.forEach(item => this.addQueryCondition('orgType', item, item));
      }

      if (conditions.isCustomer) {
        this.addQueryCondition('isCustomer', true, '既有客戶');
      }
      if (conditions.isInvoice) {
        this.addQueryCondition('isInvoice', true, '有發票');
      }
      if (conditions.isImport) {
        this.addQueryCondition('isImport', true, '有進口');
      }
      if (conditions.isExport) {
        this.addQueryCondition('isExport', true, '有出口');
      }
      if (conditions.isFactory) {
        this.addQueryCondition('isFactory', true, '有工廠');
      }

      if (conditions.capital && (conditions.capital.start || conditions.capital.end || conditions.capital.range)) {
        const capDisplay = conditions.capital.range || `${conditions.capital.start}萬~${conditions.capital.end}萬`;
        this.addQueryCondition('capital', conditions.capital, capDisplay);
      }

      if (conditions.setupDate && (conditions.setupDate.start || conditions.setupDate.end || conditions.setupDate.range)) {
        const setupDisplay = conditions.setupDate.range || `${conditions.setupDate.start} ~ ${conditions.setupDate.end}`;
        this.addQueryCondition('setupDate', conditions.setupDate, setupDisplay);
      }

      if (Array.isArray(conditions.industryCode)) {
        conditions.industryCode.forEach(code => this.addQueryCondition('industryCode', code, code));
      }

      if (conditions.location && (conditions.location.city || conditions.location.district || conditions.location.area)) {
        let displayText = '';
        if (conditions.location.city && conditions.location.district) {
          displayText = `${conditions.location.city}${conditions.location.district}`;
        } else if (conditions.location.city) {
          displayText = conditions.location.city;
        } else {
          displayText = conditions.location.area || '';
        }

        this.addQueryCondition(
          'location',
          {
            area: conditions.location.area || '',
            city: conditions.location.city || '',
            district: conditions.location.district || '',
          },
          displayText
        );

        if (conditions.location.district) {
          this.selectedAreaValue = [conditions.location.area || '全部', conditions.location.city || '全部', conditions.location.district];
        } else if (conditions.location.city) {
          this.selectedAreaValue = [conditions.location.area || '全部', conditions.location.city];
        } else {
          this.selectedAreaValue = [conditions.location.area || '全部'];
        }
      }

      if (conditions.comloc) {
        this.addQueryCondition('comloc', conditions.comloc, conditions.comloc);
      }

      this.keyword = this.queryConditions.keyword || '';
      this.IsCustomer = !!this.queryConditions.isCustomer;
      this.IsInvoice = !!this.queryConditions.isInvoice;
      this.IsImport = !!this.queryConditions.isImport;
      this.IsExport = !!this.queryConditions.isExport;
      this.IsFactory = !!this.queryConditions.isFactory;
      this.selectedComStatus = this.queryConditions.companyStatus || '全部';
    },

    async getBranchDist() {
      const { branchArea, branchCity, branchDist } = this.$store.state;
      if (branchArea && branchCity) {
        if (branchDist) {
          this.selectedAreaValue = [branchArea, branchCity, branchDist];
        } else {
          this.selectedAreaValue = [branchArea, branchCity];
        }

        await this.$nextTick();
        this.handleAreaChange(this.selectedAreaValue);
      }
    },

    async getPreferences() {
      const applyDefaultConditions = async () => {
        await this.getBranchDist();
        this.addQueryCondition('companyStatus', '營業中', '營業中');
      };

      if (!this.btnAdvFuncVisible) {
        await applyDefaultConditions();
        return;
      }

      try {
        const funs = this.$store.getters.userInfo || {};
        let deptID = funs.DeptID;
        if (deptID === 'H77' || deptID === '041' || deptID === 'H07') {
          deptID = 999;
        }

        const qry = {
          Page_Num: 1,
          Page_Size: 1,
          DeptID: deptID,
          isSys: true,
        };

        const res = await this.$api.apidivison.division_info_list(qry);
        if (res && res.total === 1 && res.data && res.data[0] && res.data[0].Parameters) {
          const qc = JSON.parse(res.data[0].Parameters);
          this.rebuildFromQueryConditions(qc);
          return;
        }

        await applyDefaultConditions();
      } catch (err) {
        console.log(err);
        await applyDefaultConditions();
      }
    },

    async applyRouteKeywordSearch() {
      const rawKeyword = this.$route.query.keyword;
      let qKeyword = '';
      if (typeof rawKeyword === 'string') {
          try {
              qKeyword = decodeURIComponent(rawKeyword);
          } catch (e) {
              qKeyword = rawKeyword;
          }
      }      
      const qCategory = (this.$route.query.category || '').toString().trim();
      const qType = (this.$route.query.type || '').toString().trim();

      if (qCategory && qKeyword && qType) {
        this.clearAllQueryConditions();
        // 加工import_value, export_value, 原因是我在前端有加工文件,要拿掉才能正確搜尋到資料庫裡的標籤
        if( qCategory=='import_value' || qCategory=='export_value' ) {
            qKeyword = qKeyword.replace(/\s*進口\s*/g, '_').replace(/\s*出口\s*/g, '_').replace(/級/g, ''); 
        }      
        console.log('從路由參數套用搜尋條件:', { qCategory, qKeyword, qType });  
        this.addQueryCondition('preciseTag', {
          category: qCategory,
          name: qKeyword,
        }, '', qType);
        this.keyword = '';
        this.listQuery.Page_Num = 1;
        this.searchExpanded = false;
        await this.getList();
        return true;
      }

      if (!qKeyword) {
        return false;
      }

      // 先移除舊 keyword 標籤，避免重複
      this.lstQuery = this.lstQuery.filter(tag => {
        const mapping = this.queryConditionMap.get(tag);
        if (mapping && mapping.type === 'keyword') {
          this.queryConditionMap.delete(tag);
          return false;
        }
        return true;
      });

      this.keyword = qKeyword;
      this.addQueryCondition('keyword', qKeyword, qKeyword);
      this.listQuery.Page_Num = 1;
      this.searchExpanded = false;
      await this.getList();
      return true;
    },
  },

  async mounted() {
    await this.getFunctions();
    this.loadSaveSearchfromAPI();
    this.loadHotTags();
    await this.loadProjectNameList();

    // 若帶有 query.comloc，進頁後自動以地址搜尋
    const rawComloc = this.$route.query.comloc;
    if (rawComloc) {
      let qComloc = '';
      try { qComloc = decodeURIComponent(rawComloc); } catch (e) { qComloc = rawComloc; }
      if (qComloc) {
        this.clearAllQueryConditions();
        this.addQueryCondition('comloc', qComloc, qComloc);
        this.listQuery.Page_Num = 1;
        this.searchExpanded = false;
        await this.getList();
        return;
      }
    }

    // 仿照桌面版：若帶有 query.keyword，進頁後自動搜尋
    const routeKeywordApplied = await this.applyRouteKeywordSearch();
    if (routeKeywordApplied) {
      return;
    }

    await this.getPreferences();
    await this.getList();
  },
};
</script>

<style lang="scss" scoped>
$primary: #1c2d5e;
$active:  #2a5caa;

// ── 根容器 ───────────────────────────────────────────────────
.m-ctm-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: #f4f6fb;
}

// ── 搜尋列 ───────────────────────────────────────────────────
.m-search-bar {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 4px;
}

.m-search-toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 600;
  color: $primary;
  font-size: 15px;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  .m-toggle-right {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.m-cond-badge {
  background: $active;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.m-search-body {
  padding: 0 12px 12px;
}

// ── 條件區塊（對應桌面版 searchWrap）───────────────────────────
.m-section {
  background: #fff;
  border: 1px solid #e8eaf0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
}

.m-section-label {
  font-size: 13px;
  font-weight: 700;
  color: $primary;
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 2px solid #e8eaf0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.m-search-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.m-search-row-extra-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.m-field-inline {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  min-width: 0;

  label {
    white-space: nowrap;
    flex-shrink: 0;
    font-weight: 600;
    font-size: 13px;
    color: #555;
  }

  // 讓 DistSelection / el-input 填滿剩餘空間
  > :not(label) { flex: 1; min-width: 0; }
}

.m-form-row {
  margin-bottom: 12px;
  label {
    display: block;
    font-weight: 600;
    font-size: 13px;
    color: #555;
    margin-bottom: 4px;
  }
}

.m-active-tags {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px;
  margin-bottom: 12px;
}

.m-active-tags-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.m-active-tags-main {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  gap: 8px;
}

.m-active-tags-label {
  padding-top: 2px;
  flex-shrink: 0;
}

.m-active-tags-list {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
  gap: 6px;
}

// ── 篩選條件列（一行 flex 排列） ────────────────────────────
.m-filter-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.m-filter-label {
  font-weight: 700;
  font-size: 13px;
  color: $primary;
  flex-shrink: 0;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}

// ── 篩選捲動列（已廢棄，保留向後相容） ────────────────────────────
.m-filter-scroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  gap: 8px;
  padding-bottom: 8px;
  margin-bottom: 8px;
  &::-webkit-scrollbar { display: none; }
}

.m-filter-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 16px;
  background: #fff;
  font-size: 13px;
  color: #303133;
  cursor: pointer;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
}

// ── Checkbox 列（已廢棄，保留向後相容） ──────────────────────────
.m-checkbox-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 12px;
  font-size: 13px;
}

// ── 搜尋動作 ─────────────────────────────────────────────────
.m-search-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.m-search-actions--inline {
  margin-top: 0;
  margin-left: auto;
}

// ── 結果標頭 ─────────────────────────────────────────────────
.m-result-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  font-size: 13px;
  color: #666;
  border-bottom: 1px solid #eee;
  margin-bottom: 4px;
  flex-wrap: wrap;  
  gap: 8px;

  .m-batch-btns {
    display: flex;
    gap: 6px;
    margin-left: auto;
  }
}

// ── 卡片列表 ─────────────────────────────────────────────────
.m-card-list {
  flex: 1;
  padding: 8px 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.m-empty {
  margin-top: 40px;
}

// ── 公司卡片 ─────────────────────────────────────────────────
.m-company-card {
  background: #fff;
  border-radius: 10px;
  padding: 0.3rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  border-left: 4px solid transparent;
  transition: border-color 0.2s;

  &--selected {
    border-left-color: $active;
    background: #f0f5ff;
  }
}

.m-card-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.m-card-check {
  flex-shrink: 0;
}

.m-card-name {
  flex: 1;
  font-size: 1rem;
  font-weight: 700;
  color: #1a3a6e;
  cursor: pointer;
  word-break: break-all;
  line-height: 1.6;
  margin-top: 4px;
  text-decoration: underline;
  -webkit-tap-highlight-color: transparent;
}

.m-card-unicom {
  flex-shrink: 0;
  font-size: 1rem;
  padding: 2px 6px;
  color: $active;
  text-decoration: underline;
  cursor: pointer;
  white-space: nowrap;
}

.m-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
}

.m-tag {
  font-size: 11px;
}

.m-card-info {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px 12px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #888;
  min-width: 0;

  span {
    display: flex;
    align-items: center;
    gap: 3px;
    white-space: nowrap;
  }

  .m-card-loc {
    min-width: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.m-card-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: auto;
}

// ── 分頁 ─────────────────────────────────────────────────────
.m-pagination {
  padding: 12px 8px;
  background: #fff;
  margin-top: 4px;
  display: flex;
  justify-content: center;
}

// ── 標籤抽屜 ─────────────────────────────────────────────────
.m-tag-drawer {
  padding: 16px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.m-tags-section-title {
  font-weight: 700;
  font-size: 14px;
  color: $primary;
  margin-bottom: 8px;
}

.m-tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.m-tag-drawer-add {
  margin-top: auto;
  padding-top: 16px;
  border-top: 1px solid #eee;
}

// ── Dialog 表單 ───────────────────────────────────────────────
.m-dialog-form {
  padding: 0 4px;
}

.m-form-item {
  margin-bottom: 16px;
  label {
    display: block;
    font-weight: 600;
    font-size: 13px;
    margin-bottom: 6px;
    color: #555;
  }
}

.m-form-value {
  font-size: 14px;
  color: #303133;
  padding: 4px 0;
}

// ── 熱門標籤 ─────────────────────────────────────────────────
.dialogBox {
  width: 100%;
  height: 260px;
}

.m-hot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  padding: 8px;
  justify-content: center;
}

.m-hot-tag {
  cursor: pointer;
  color: #1c2d5e;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
  line-height: 1.6;

  &:active {
    background: #e8eeff;
  }
}

::v-deep .m-hot-tag-dialog .el-dialog__footer {
  position: relative;
  z-index: 99999;
}

::v-deep .m-hot-tag-dialog .el-dialog__footer .el-button {
  position: relative;
  z-index: 100000;
}
</style>
